import { render } from "./Pdf.vue?vue&type=template&id=32938d92"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"
script.render = render

export default script